import { prop } from 'ramda';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useSnackbar } from '#hooks';
import services from '#services';
import { actions } from '#store';

const useCompanies = () => {
  const { enqueueErrorSnackbar } = useSnackbar();
  const state = useSelector(prop('companies'));
  const dispatch = useDispatch();

  const fetch = useCallback(async (query, { enableSnackbar } = {}) => {
    try {
      dispatch(actions.companies.fetch.creator());
      const companies = await services.bob.companies.getAll(query);
      dispatch(actions.companies.fetchSuccess.creator({ payload: companies }));
      return companies;
    } catch (err) {
      dispatch(actions.companies.fetchError.creator({ error: err.message }));
      if (enableSnackbar) {
        enqueueErrorSnackbar(err.message, {
          persist: true,
          buttons: [{
            text   : 'retry',
            onClick: () => fetch(query, { enableSnackbar }),
          }],
        });
        return null;
      }
      throw err;
    }
  }, [dispatch]);

  return {
    ...state,
    handlers: {
      fetch,
    },
  };
};

export default useCompanies;
